export enum orderStatus {
  inProgress = 'IN PROGRESS',
  waitConfirmation = 'WAIT CONFIRMATION',
  confirmed = 'CONFIRMED',
  rejected = 'REJECTED',
  cancelled = 'CANCELLED',
  deleted = 'DELETED',
  closed = 'CLOSED',
}
